import React, { useMemo, useState } from 'react';
import { Card, Button, Table, Space, Modal, Input, Form } from 'antd';
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import useCoachCourses from '../hooks/useCoachCourses';

const MyCourseSelector = ({ 
  open, 
  onCancel, 
  onCourseSelect,
  selectedCourseIds = []
}) => {
  const { courses, loading, pagination, fetchCourses, addCourse, updateCourse, deleteCourse } = useCoachCourses();
  const [searchForm] = Form.useForm();
  
  const handleSearch = () => {
    // 这里可以添加搜索逻辑，但目前我们只使用hook提供的数据
    const values = searchForm.getFieldsValue();
    // 简单的客户端搜索过滤
    console.log('搜索条件:', values);
    fetchCourses(1, pagination.pageSize);
  };

  const handleReset = () => {
    searchForm.resetFields();
    fetchCourses(1, pagination.pageSize);
  };

  const handleOk = () => {
    // 不需要任何操作，因为选择会在行点击时触发
  };

  const columns = useMemo(
    () => [
      {
        title: '课程名称',
        dataIndex: 'courseDesc',
        key: 'courseDesc',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
          <div style={{ padding: 8 }}>
            <Input
              placeholder="搜索课程名称"
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => confirm()}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: 90 }}
              >
                搜索
              </Button>
              <Button
                onClick={() => {
                  setSelectedKeys([]);
                  confirm();
                  handleReset();
                }}
                size="small"
                style={{ width: 90 }}
              >
                重置
              </Button>
            </Space>
          </div>
        ),
        onFilter: (value, record) => {
          if (!value) return true;
          return record.courseDesc.toLowerCase().includes(value.toLowerCase());
        },
      },
      {
        title: '课程定价',
        dataIndex: 'coursePrice',
        key: 'coursePrice',
        render: (value) => `¥${value ?? '-'}`,
        sorter: (a, b) => (a.coursePrice || 0) - (b.coursePrice || 0),
      },
      {
        title: '关联动作',
        key: 'relateActions',
        render: (_, record) => {
          // 优先使用relateActionShow，否则从relateActions生成展示内容
          return record.relateActionShow || (record.relateActions && Array.isArray(record.relateActions) ? record.relateActions.map((action) => action.eventTitle).join(', ') : '-') || '-';
        },
      },
      {
        title: '操作',
        key: 'actions',
        width: 120,
        render: (_, record) => (
          <Button 
            type="link" 
            onClick={() => {
              // 传递选中的课程及其关联的动作
              onCourseSelect(record);
            }}
          >
            选择
          </Button>
        ),
      },
    ],
    [onCourseSelect]
  );

  // 过滤掉已选中的课程
  const filteredCourses = courses.filter(course => !selectedCourseIds.includes(course.id));

  return (
    <Modal
      open={open}
      title="我的课程选择器"
      width={1000}
      onCancel={onCancel}
      onOk={handleOk}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          取消
        </Button>
      ]}
      destroyOnClose
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <Card>
          <Form form={searchForm} layout="inline" style={{ marginBottom: 16 }}>
            <Form.Item name="courseDesc" label="课程名称">
              <Input placeholder="请输入课程名称" />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>
                  搜索
                </Button>
                <Button icon={<ReloadOutlined />} onClick={handleReset}>
                  重置
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
        <Table
          columns={columns}
          rowKey="id"
          loading={loading}
          dataSource={filteredCourses}
          pagination={{
            ...pagination,
            onChange: (page, pageSize) => fetchCourses(page, pageSize),
          }}
          rowClassName={(record) => 
            selectedCourseIds.includes(record.id) ? 'selected-row' : ''
          }
        />
      </Space>
    </Modal>
  );
};

export default MyCourseSelector;